var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.326,
    height: 11.555,
    viewBox: "0 0 17.326 11.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M18.924,11.473a.786.786,0,0,0-.006,1.107l3.659,3.665H8.651a.782.782,0,0,0,0,1.565H22.571l-3.659,3.665a.792.792,0,0,0,.006,1.107.779.779,0,0,0,1.1-.006l4.959-4.995h0a.879.879,0,0,0,.162-.247.747.747,0,0,0,.06-.3.784.784,0,0,0-.223-.548l-4.959-4.995A.767.767,0,0,0,18.924,11.473Z",
    transform: "translate(25.201 22.807) rotate(180)",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ed56801869c0794b7d87529acd13cdab.svg";
export { ForwardRef as ReactComponent };